import { css } from '@emotion/react';
import { theme } from '../../domain/theme';

export const imgTkover = css`
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding-bottom: 60px;
  position: fixed;
  top: 0;
  left: 0;
  background: #222;
  z-index: 299;

  ${theme.mq.small_desktop} {
    & {
      padding-right: 63px;
      overflow-x: hidden;
    }

    & h5 {
      display: none;
    }
  }
`;

export const imgTkoverAuthor = css`
  ${theme.mq.small_desktop} {
    & {
      font-size: 0.75rem;
    }
  }
`;

export const imgTkoverCloseBtn = css`
  color: #fff;
  height: 50px;
  position: absolute;
  right: 0;
  width: 50px;
  font-size: 1.5625rem;
  line-height: 3.125rem;
  text-align: center;

  &:hover {
    cursor: pointer;
  }

  ${theme.mq.small_desktop} {
    & {
      position: absolute;
      right: -56px;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;

export const imgTkoverCollapse = css`
  position: relative;
  top: 7px;
  margin-bottom: 59px;

  & .close {
    ${theme.font.family('boldWeb')};
    font-weight: 400;
    letter-spacing: 3px;
    line-height: 1.5;
    font-style: normal;
    color: #fff;
    position: absolute;
    right: 60px;
    text-transform: uppercase;
    top: -9px;
    font-size: 0.75rem;
  }

  & .close:hover {
    cursor: pointer;
  }

  ${theme.mq.small_desktop} {
    & {
      height: 0;
      margin-bottom: 0;
    }
  }
`;

export const imgTkoverCont = css`
  border-left: 1px solid #555;
  margin: 20px 30px 40px;
  padding-left: 15px;

  ${theme.mq.tablet} {
    & {
      margin: 20px 45px 20px 35px;
      padding-left: 30px;
    }
  }

  ${theme.mq.small_desktop} {
    & {
      margin: 20px 360px 40px 60px;
      padding-left: 50px;
    }
  }

  ${theme.mq.large_desktop} {
    & {
      margin: 30px 400px 30px 60px;
      padding-left: 40px;
    }
  }
`;

export const imgTkoverContAuthor = css`
  ${theme.font.family('regularWeb')};
  font-weight: 400;
  font-size: 0.75rem;
  letter-spacing: 3px;
  line-height: 1.5;

  color: #555;
  text-transform: uppercase;

  ${theme.mq.tablet} {
    & {
      ${theme.font.family('regularWeb')};
      font-weight: 400;
      font-size: 0.9375rem;
      letter-spacing: 2.5px;
      line-height: 1.5;
      font-size: 0.75rem;
    }
  }
`;

export const imgTkoverContCopy = css`
  ${theme.font.family('regularWeb')};
  font-weight: 400;
  font-size: 0.9375rem;
  letter-spacing: 0.1px;
  line-height: 1.5;

  color: #999;
  margin-bottom: 20px;

  & p {
    font-family: inherit;
    font-weight: inherit;
    font-size: inherit;
    letter-spacing: inherit;
    line-height: inherit;
    color: inherit;
    margin: 0;
    a {
      color: inherit;
      border-bottom: 1px solid #fc0;
    }
  }

  ${theme.mq.tablet} {
    & {
      font-size: 0.9375rem;
      line-height: 1.625rem;
    }
  }
`;

export const imgTkoverContCredit = css`
  ${theme.font.family('regularWeb')};
  font-weight: 400;
  font-size: 0.75rem;
  letter-spacing: 3px;
  line-height: 1.5;

  color: #555;
  text-transform: uppercase;

  ${theme.mq.tablet} {
    & {
      ${theme.font.family('regularWeb')};
      font-weight: 400;
      font-size: 0.9375rem;
      letter-spacing: 2.5px;
      line-height: 1.5;
      font-size: 0.75rem;
    }
  }
`;

export const imgTkoverContStrong = css`
  color: #fff;
  text-transform: uppercase;
`;

export const imgTkoverCredit = css`
  ${theme.mq.small_desktop} {
    & {
      font-size: 0.75rem;
    }
  }
`;

export const imgTkoverImage = css`
  margin-top: 50px;

  ${theme.mq.small_desktop} {
    & {
      margin-top: 0;
    }
  }
`;
